import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import CancellationPolicyService from '../../api/services/CancellationPolicyService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const CancellationPolicy = () => {
    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL + 'Policy/';
    const [voucher, setVoucher] = useState([]);
    const [Error, setError] = useState('');
    const navigate = useNavigate();
    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = voucher.slice(firstIndex, lastIndex);
    const npage = Math.ceil(voucher.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            getCancellationPolicy();
        }
        else {
            navigate('/')
        }
    }, []);
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getCancellationPolicy = async () => {
        try {
            let blogList = await CancellationPolicyService.index().json();
            setVoucher(blogList.data);
            setisloading(false);
        } catch (error) {
            console.log(error);
        }
    };
    const handleDelete = async (e) => {
        try {


            let responseData = await CancellationPolicyService.destroy(e).json()
            if (responseData.status === true) {
                swal("Cancellation Policy Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getCancellationPolicy();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    return (
        <>
            <MainPagetitle mainTitle="Cancellation Policy" pageTitle={'Cancellation Policy'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Cancellation Policy</h4>
                                        <div>
                                            <Link to={`/admin/add-cancellation-policy/`} className="btn btn-primary btn-sm ms-1">+ Add Cancellation Policy</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Title</th>
                                                    <th>Price</th>
                                                    <th>Image</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{index + 1}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.title}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {item.price}
                                                        </td>
                                                        <td><img height={item.icon ? 50 : 0} width={item.icon ? 50 : 0} src={imageUrl + item.icon} alt='brand' /></td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                    to={`/admin/edit-cancellation-policy/${item.id}`}
                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </Link>

                                                                <Link
                                                                    onClick={() =>
                                                                        swal({
                                                                            title: "Are you sure?",
                                                                            text: "Once deleted, you will not be able to recover this data!",
                                                                            icon: "warning",
                                                                            buttons: true,
                                                                            dangerMode: true,
                                                                        }).then((willDelete) => {
                                                                            if (willDelete) {
                                                                                (handleDelete(item.id));
                                                                            }
                                                                        })
                                                                    }
                                                                    className="btn btn-danger shadow btn-xs sharp"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {voucher.length < lastIndex ? voucher.length : lastIndex}
                                                {" "}of {voucher.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default CancellationPolicy;